module.exports = __webpack_public_path__ + "static/media/2.20c1a08c.svg";